import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Box, TablePagination } from "@mui/material";
import Moment from "moment";
import { useNavigate } from "react-router-dom";
import DataTable from "../../../Table/DataTable";
import { SESSION_AUTH } from "../../../../helpers/auth";
import { getModuleAllPermissions } from "../../../../helpers/utils";
import { ToastManager } from "../../../common/ToastContainer";
import { EVENTS_SERVICES } from "../../../../services";
import FullPageProgress from "../../../common/FullPageProgress";
import EventOrgazinationNewsRemove from "./EventOrgazinationNewsRemove";
import EventOrgazinationNewsAdd from "./EventOrgazinationNewsAdd";
import EventOrgazinationNewsTrack from "./EventOrgazinationNewsTrack";

const EventOrgazinationNews = (props) => {
  const { accountId } = useParams();
  const { module } = props;
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const navigate = useNavigate();
  const [dataFetched, setDataFetched] = useState(false);
  const [userData, setUserData] = useState("");
  const [loader, setLoader] = useState(false);
  const [modulePermissions, setModulePermissions] = useState();
  const [orgList, setOrgList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const defaultFilter = {
    page: 0,
    limit: 10,
    accountId: accountId,
  };
  const [filter, setFilter] = useState(defaultFilter);

  const handleChangePage = (event, newPage) => {
    setFilter((old) => ({
      ...old,
      page: newPage,
    }));
    setDataFetched(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setFilter((old) => ({
      ...old,
      limit: event.target.value,
      page: 0,
    }));
    setDataFetched(false);
  };

  useEffect(() => {
    if (userSession) {
      setModulePermissions(getModuleAllPermissions(userSession, module));
      setUserData(userSession);
    } else {
      setModulePermissions("");
      setUserData("");
    }
    return () => null;
  }, [userSession, module]);

  useEffect(() => {
    if (!userData || dataFetched || !modulePermissions?.view) return;

    setLoader(true);
    setDataFetched(true);

    let parma = { ...filter };
    parma["userId"] = userData.userId;

    EVENTS_SERVICES.getNews(parma)
      .then((data) => {
        setOrgList([]);
        if (data.code === 200) {
          setOrgList(data?.data?.list || []);
          if (data?.data.pageInfo.page === 0) {
            setTotalRows(data?.data.pageInfo?.count || 0);
          }
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  }, [userData, dataFetched, LOGOUT_USER_SESSION, modulePermissions, filter]);

  useEffect(() => {
    if (userData && !modulePermissions?.view) {
      return navigate("/");
    }
  }, [modulePermissions, userData, navigate]);

  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    { name: "sno", label: "S.No." },
    {
      name: "title",
      label: "Title",
      options: {
        customBodyRender: (value) => {
          return (
            <Link
              to={`${process.env.REACT_APP_EVENT_PLATFORM}/news/${value?.slug}`}
              target="_blank"
              className="text-link"
              style={{ whiteSpace: "normal" }}
            >
              {value?.title}
            </Link>
          );
        },
      },
    },
    { name: "createdAt", label: "Created" },
    { name: "source", label: "Source" },

    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (item) => {
          return (
            <>
              {modulePermissions?.add ? (
                <>
                  <EventOrgazinationNewsRemove
                    news={item}
                    onUpdate={() => {
                      setDataFetched(false);
                    }}
                  />
                </>
              ) : null}
            </>
          );
        },
      },
    },
  ];
  const customOption = {
    pagination: false,
    sort: false,
  };

  return (
    <>
      {modulePermissions?.add && (
        <div className="managepro6ix-layout-page-content-header pt-0">
          <div className="managepro6ix-layout-page-content-header-action">
            <EventOrgazinationNewsTrack />

            <EventOrgazinationNewsAdd
              onUpdate={() => {
                setDataFetched(false);
              }}
            />
          </div>
        </div>
      )}

      {loader && <FullPageProgress />}
      <Box className="managepro6ix-layout-page-content">
        <DataTable
          customOption={customOption}
          columns={columns}
          data={orgList.map((item, key) => {
            return {
              sno: filter?.page * filter?.limit + key + 1,

              title: { title: item?.title, slug: item?.slug },
              createdAt: Moment(item?.createdAt).format(
                "MMM DD, YYYY : hh:mm A",
              ),
              source: item?.source,
              id: item?._id,
              action: item,
            };
          })}
        />

        <TablePagination
          component="div"
          count={totalRows}
          page={filter.page}
          onPageChange={handleChangePage}
          rowsPerPage={filter.limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton={true}
          showLastButton={true}
        />
      </Box>
    </>
  );
};

export default EventOrgazinationNews;
